export default __webpack_public_path__ + "static/media/grua.8c6749ad.png";